export function formatCurrency(value: number) {
  const moneyFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: window.localStorage.getItem("currencyFormat") || "USD",
    minimumFractionDigits: 2,
  });

  return moneyFormat.format(value);
}
